import "./RecordList.css";

export function RecordList({ children, className = "" }) {
  return <div className={`record-list ${className}`.trim()}>{children}</div>;
}
